import React from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles, Typography } from '@material-ui/core';
import useStyles from '../ButtonActions/styles';

/**
 *
 * @param {String} label - button text
 * @param {String} color - color for background to use from Material ui palette
 * @param {Object} styles - colour palette to be used if not present in the theme; background and label
 *
 */
const ButtonActionsWhite = ({ label, color, styles, children }) => {
  const classes = useStyles();

  const propsBackgroundColor = styles?.background ? styles.background : '';
  const propsRadius = styles?.radius ? styles.radius : '';
  const propsLabel = styles?.label ? styles.label : '';

  return (
    <Button
      variant="contained"
      color={color}
      fullWidth={true}
      className={`${classes.root} ${classes[propsBackgroundColor]} ${classes[propsRadius]} ${classes[propsLabel]} `}
    >
      {children ? children : <span className={classes.span}>{label}</span>}
    </Button>
  );
};

ButtonActionsWhite.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  styles: PropTypes.object,
};

export default ButtonActionsWhite;
